export class Lab {
    id: string;
    organizationLevelId: string;
    labIntegrationType: number;
    emailEdd: string;
    reportTo: string;
    reportToCompanyName: string;
    reportToAddress1: string;
    reportToAddress2: string;
    reportToCity: string;
    reportToState: string;
    reportToZip: string;
    reportToPhoneNumber: string;
    reportToCellNumber: string;
    reportToEmail: string;
    invoiceTo: string;
    invoiceCompanyName: string;
    invoiceComments: string;
    invoiceAddress1: string;
    invoiceAddress2: string;
    invoicePhoneNumber: string;
    invoicePoNumber: string;
    invoiceEmail: string;
    invoicePaymentInfo: string;
    labName: string;
    labAccountNumber: string;
    labAddress1: string;
    labAddress2: string;
    labCity: string;
    labState: string;
    labZip: string;
    labPhoneNumber: string;
    labCellNumber: string;
    labEmail: string;
    tats: TAT[];
    sampleIds?: string[];
    applyBlankCorrection: boolean;
    sameAsReportToAddress?: boolean;
    enforceBlankRules?: boolean;
    minBlankCount?: number | null;        // null ⇒ tenant/system default applies
    minBlankRatioPercent?: number | null; // null ⇒ tenant/system default applies
    cocReportTemplateId?: string | null;
}

export interface TAT {
    id: string;
    turnAroundTime: string;
    surcharge: string;
}